import { useForgotPasswordMutation } from '../../apis/passwordApi';

// @ts-ignore
const hasVerified = window.HAS_VERIFIED || false;
const useForgotPassword = () => {
    const [forgotPassword, { isLoading, isSuccess, isError, reset }] = useForgotPasswordMutation();

    return {
        forgotPassword,
        isLoading,
        hasCompleted: isSuccess || isError || hasVerified, // For security reasons we do not show errors for non-existent usernames.
        reset,
    };
};
export default useForgotPassword;
